export const templateParamsRegex = new RegExp('{{\\d+}}', 'gm'); ///{{\d+}}/gm

export const fillTypes = Object.freeze({
  FREE_TEXT: 'free_text',
  CLIENT_FIELD: 'client_field',
  IMPORT_FIELD: 'import_field'
});

export const TYPES_BROADCAST_LIST = Object.freeze({
  TRANSFER_TO_QUEUE: 1,
  CLOSE_ON_FIRST_RESPONSE: 2,
  TRANSFER_TO_QUEUE_WITH_FIRST_RESPONSE: 3,
  TRANSFER_TO_FLEXIA: 4,
  CLOSE_AFTER_SEND: 5,
  TRANSFER_TO_FLEXIA_WITH_PROTOCOL: 6
});

export const BroadcastListWithExpirationDay = [
  TYPES_BROADCAST_LIST.CLOSE_ON_FIRST_RESPONSE,
  TYPES_BROADCAST_LIST.TRANSFER_TO_QUEUE_WITH_FIRST_RESPONSE,
  TYPES_BROADCAST_LIST.TRANSFER_TO_DIALOG_TREE,
  TYPES_BROADCAST_LIST.TRANSFER_TO_WATSON,
  TYPES_BROADCAST_LIST.TRANSFER_TO_DIALOG_TREE_WITH_PROTOCOL
];

export const broadcastTypeOfClosingConversationOptions = [
  {
    label: 'Transferir para fila',
    value: TYPES_BROADCAST_LIST.TRANSFER_TO_QUEUE
  },
  {
    label: 'Transferir para fila com primeira resposta',
    value: TYPES_BROADCAST_LIST.TRANSFER_TO_QUEUE_WITH_FIRST_RESPONSE
  },
  {
    label: 'Encerrar na primeira resposta',
    value: TYPES_BROADCAST_LIST.CLOSE_ON_FIRST_RESPONSE
  },
  {
    label: 'Encerrar conversa após envio',
    value: TYPES_BROADCAST_LIST.CLOSE_AFTER_SEND
  },
  {
    label: 'Transferir para a FlexIA',
    value: TYPES_BROADCAST_LIST.TRANSFER_TO_FLEXIA
  },
  {
    label: 'Transferir para FlexIA com protocolo',
    value: TYPES_BROADCAST_LIST.TRANSFER_TO_FLEXIA_WITH_PROTOCOL
  }
];

export const broadcastTypeToLabelMapper = {
  [TYPES_BROADCAST_LIST.TRANSFER_TO_QUEUE]: 'Transferir para fila',
  [TYPES_BROADCAST_LIST.CLOSE_ON_FIRST_RESPONSE]:
    'Encerrar na primeira resposta',
  [TYPES_BROADCAST_LIST.TRANSFER_TO_QUEUE_WITH_FIRST_RESPONSE]:
    'Transferir para fila com primeira resposta',
  [TYPES_BROADCAST_LIST.TRANSFER_TO_DIALOG_TREE]:
    'Transferir para a Árvore de Diálogo',
  [TYPES_BROADCAST_LIST.TRANSFER_TO_WATSON]: 'Transferir para o Watson',
  [TYPES_BROADCAST_LIST.CLOSE_AFTER_SEND]: 'Encerrar conversa após envio',
  [TYPES_BROADCAST_LIST.TRANSFER_TO_DIALOG_TREE_WITH_PROTOCOL]:
    'Transferir para Árvore de Diálogo com protocolo'
};
